<template>
  <div>
    <div class="text-right mb-3">
      <button
        type="button"
        class="btn btn-light btn-sm btn-with-addon"
        @click="print"
      >
        <span class="btn-addon">
          <i class="btn-addon-icon fe fe-printer" />
        </span>
        Print
      </button>
    </div>
    <div class="air__utils__scrollTable mb-4">
      <a-table
        :rowKey="record => record.id"
        :columns="columns"
        :dataSource="data"
        :pagination="false"
        :scroll="{ x: '100%' }"
        :rowSelection="computedSelect"
        :loading="loading"
      >
        <template slot="application_id" slot-scope="application_id">
          <div>
            <div class="font-weight-bold text-wrap">{{application_id}}</div>
          </div>
        </template>
        <template slot="applicant" slot-scope="applicant">
          <div>
            <div class="font-weight-bold text-wrap">{{applicant.student_first_name}} {{applicant.student_last_name}}</div>
          </div>
        </template>
        <template slot="contact" slot-scope="contact">
          <div class="font-weight-bold">{{contact.contact_country_code}}{{contact.contact_phone}}</div>
        </template>
        <template slot="last_school_name" slot-scope="last_school_name">
          <span class="text-wrap">{{last_school_name}}</span>
        </template>
        <template slot="pc_score" slot-scope="pc_score">
          <span>{{pc_score ? pc_score + '%' : 'NA'}}</span>
        </template>
        <template slot="created_at" slot-scope="created_at">
          <span class="font-weight-bold">{{moment(created_at).format('DD-MM-YYYY')}}</span>
        </template>
        <template slot="form_status" slot-scope="form_status">
          <span>{{getFormStatus(form_status)}}</span>
        </template>
        <template slot="status" slot-scope="status">
          <span>{{getStatus(status)}}</span>
        </template>
        <template slot="action" slot-scope="text, record">
          <div class="text-nowrap" v-if="record.status < 1">
            <!-- Approve -->
            <a href="javascript:;"
              :class="['btn btn-sm btn-success btn-with-addon mr-2', record.form_status !== 3 ? 'disabled' : '']"
              @click="handleApprove(record)"
            >
              <span class="btn-addon">
                <i class="btn-addon-icon fe fe-check" />
              </span>
              <!-- <edit-board ref="editBoard" @edited="handleEdited"/> -->
              Approve
            </a>
            <!-- Decline -->
            <a href="javascript:;"
              :class="['btn btn-sm btn-danger btn-with-addon mr-2', record.form_status !== 3 ? 'disabled' : '']"
              @click="handleDecline(record)"
            >
              <span class="btn-addon">
                <i class="btn-addon-icon fe fe-x" />
              </span>
              <!-- <edit-board ref="editBoard" @edited="handleEdited"/> -->
              Decline
            </a>
            <!-- View -->
            <a href="javascript:;" class="btn btn-sm btn-primary btn-with-addon"
              @click="showViewModal(record)"
            >
              <span class="btn-addon">
                <i class="btn-addon-icon fe fe-eye" />
              </span>
              View
            </a>
          </div>
          <div class="text-nowrap" v-else>
            <!-- Admit -->
            <a v-if="record.status === 2" href="javascript:;"
              :class="['btn btn-sm btn-success btn-with-addon mr-2', record.form_status !== 3 ? 'disabled' : '']"
              @click="handleAdmit(record)"
            >
              <span class="btn-addon">
                <i class="btn-addon-icon fe fe-check" />
              </span>
              <!-- <edit-board ref="editBoard" @edited="handleEdited"/> -->
              Admit
            </a>
            <!-- Decline -->
            <a v-if="record.status === 1" href="javascript:;"
              :class="['btn btn-sm btn-danger btn-with-addon mr-2 disabled',]"
            >
              <span class="btn-addon">
                <i class="btn-addon-icon fe fe-x" />
              </span>
              <!-- <edit-board ref="editBoard" @edited="handleEdited"/> -->
              Declined
            </a>
            <!-- Admitted -->
            <a v-if="record.status === 3" href="javascript:;"
              :class="['btn btn-sm btn-success btn-with-addon mr-2 disabled']"
            >
              <span class="btn-addon">
                <i class="btn-addon-icon fe fe-check" />
              </span>
              <!-- <edit-board ref="editBoard" @edited="handleEdited"/> -->
              Admitted
            </a>
            <!-- View -->
            <a href="javascript:;" class="btn btn-sm btn-primary btn-with-addon"
              @click="showViewModal(record)"
            >
              <span class="btn-addon">
                <i class="btn-addon-icon fe fe-eye" />
              </span>
              View
            </a>
          </div>
        </template>
      </a-table>
    </div>
    <!-- Print table -->
    <div id="applicantsTable" v-if="data" class="d-none d-print-block">
      <neo-print-wrapper title="Applicants" :footer="false" >
        <div>
          <div>
            <p class="h5 mb-4 text-center">Applicants for course/class <span class="font-weight-bold">{{applicationFormData.school_class.name}}</span>, for the session <span class="font-weight-bold">{{applicationFormData.session.name}}</span></p>
          </div>
          <table class="table table-bordered">
            <thead class="thead-light">
              <tr>
                <th scope="col">#</th>
                <th scope="col">Applicantion Id</th>
                <th scope="col">Student's name</th>
                <th scope="col">Phone</th>
                <th scope="col">Last School</th>
                <th scope="col">PC Score</th>
                <th scope="col">Registered on</th>
                <th scope="col">Form Status</th>
                <th scope="col">Status</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(applicant, index) in data" :key="applicant.id">
                <th scope="row">{{index + 1}}</th>
                <td>{{applicant.application_id}}</td>
                <td>{{applicant.student_first_name + ' ' + applicant.student_last_name }}</td>
                <td>{{applicant.contact_country_code + applicant.contact_phone }}</td>
                <td>{{applicant.last_school_name}}</td>
                <td>{{applicant.pc_score ? applicant.pc_score + '%' : ''}}</td>
                <td>{{moment(applicant.created_at).format('DD-MM-YYYY')}}</td>
                <td>{{getFormStatus(applicant.form_status)}}</td>
                <td>{{getStatus(applicant.status)}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </neo-print-wrapper>
    </div>

    <display-applicant-form @updateTable="handleUpdateTable"/>
  </div>
</template>
<script>
import moment from 'moment'
import NeoPrintWrapper from '@/components/layout/Print/Default'

import { onlineApplicantFormStatus, onlineApplicantStatus } from '@/services/globaldata.js'

import DisplayApplicantForm from '@/components/applicant/Display/index'

const columns = [
  {
    title: 'Application Id',
    dataIndex: 'application_id',
    scopedSlots: { customRender: 'application_id' },
  },
  {
    title: 'Name',
    key: 'applicant',
    scopedSlots: { customRender: 'applicant' },
  },
  {
    title: 'Phone',
    key: 'contact',
    scopedSlots: { customRender: 'contact' },
  },
  {
    title: 'Last School',
    dataIndex: 'last_school_name',
    scopedSlots: { customRender: 'last_school_name' },
  },
  {
    title: 'Score',
    dataIndex: 'pc_score',
    scopedSlots: { customRender: 'pc_score' },
  },
  {
    title: 'Registered on',
    dataIndex: 'created_at',
    scopedSlots: { customRender: 'created_at' },
  },
  {
    title: 'Form Status',
    dataIndex: 'form_status',
    scopedSlots: { customRender: 'form_status' },
  },
  {
    title: 'Status',
    dataIndex: 'status',
    scopedSlots: { customRender: 'status' },
  },
  {
    title: 'Actions',
    dataIndex: 'action',
    className: 'text-right',
    scopedSlots: { customRender: 'action' },
  },
]

export default {

  name: 'ApplicantsTable',
  components: {
    DisplayApplicantForm,
    NeoPrintWrapper,
  },
  props: {
    select: Boolean,
    loading: Boolean,
    data: {
      type: Array,
      default: () => [],
    },
    applicationFormData: Object,
  },
  data: function() {
    return {
      onlineApplicantFormStatus,
      onlineApplicantStatus,
      columns,
      selectedRowKeys: [],
      dateFormat: 'DD-MM-YYYY',
    }
  },
  computed: {
    computedSelect: function() {
      if (!this.select) {
        return null
      }
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
      }
    },
  },
  methods: {
    moment,
    print() {
      this.$htmlToPaper('applicantsTable')
    },
    getFormStatus(key) {
      return onlineApplicantFormStatus[key]
    },
    getStatus(key) {
      return onlineApplicantStatus[key]
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    showEditModal: function(record) {
      this.$eventBus.$emit('openApplicationFormEditModal', record.id)
    },
    showViewModal: function(record) {
      this.$eventBus.$emit('openShowApplicantFormModal', record.id)
    },
    handleUpdateTable: function () {
      this.$emit('updateTable')
    },
    handleApprove(record) {
      this.$confirm({
        title: 'Are you sure?',
        content: `Click OK to approve ${record.student_first_name} ${record.student_last_name}`,
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'No',
        onOk: () => {
          this.$nprogress.start()
          this.$http
            .get('/api/online-applicants/approve/' + record.id)
            .then(() => {
              this.$emit('updateTable')
              this.$nprogress.done()
              this.$notification['success']({
                message: 'Approved Successfully!',
                description: `Applicant ${record.student_first_name} ${record.student_last_name} has been approved successfully!`,
              })
            })
            .catch(error => {
              this.$nprogress.done()
              this.$neoNotify.error(error)
            })
        },
        onCancel: () => {
          console.log('Cancel')
        },
      })
    },
    handleDecline(record) {
      this.$confirm({
        title: 'Are you sure?',
        content: `Click OK to decline ${record.student_first_name} ${record.student_last_name}`,
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'No',
        onOk: () => {
          this.$nprogress.start()
          this.$http
            .get('/api/online-applicants/decline/' + record.id)
            .then(() => {
              this.$emit('updateTable')
              this.$nprogress.done()
              this.$notification['success']({
                message: 'Applicant Declined!',
                description: `Applicant ${record.student_first_name} ${record.student_last_name} has been declined!`,
              })
            })
            .catch(error => {
              this.$nprogress.done()
              this.$neoNotify.error(error)
            })
        },
        onCancel: () => {
          console.log('Cancel')
        },
      })
    },
    handleAdmit(record) {
      this.$confirm({
        title: 'Are you sure?',
        content: `Click OK to admit ${record.student_first_name} ${record.student_last_name}`,
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'No',
        onOk: () => {
          this.$nprogress.start()
          this.$http
            .get('/api/online-applicants/admit/' + record.id)
            .then(() => {
              this.$emit('updateTable')
              this.$nprogress.done()
              this.$notification['success']({
                message: 'Admitted Successfully!',
                description: `Applicant ${record.student_first_name} ${record.student_last_name} has been admitted successfully!`,
              })
            })
            .catch(error => {
              this.$nprogress.done()
              this.$neoNotify.error(error)
            })
        },
        onCancel: () => {
          console.log('Cancel')
        },
      })
    },
  },
}
</script>
